import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { RegionProvider } from '../../shared/providers/region.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { id } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  roleList:any = [];
  faqData:any = [];
  addOrEditFaq:any =''
  formGroup:FormGroup;

  submitted = false;
  editorConfig = {
    toolbarGroups: [
      { name: "clipboard", groups: ["clipboard", "undo"] },
      { name: "editing", groups: ["find", "selection", "spellchecker"] },
      { name: "links" },
      { name: "insert" },
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
      { name: "styles" },
      { name: "colors" },
    ],
    skin: "kama",
    resize_enabled: false,
    removePlugins: "elementspath,save,magicline",
    extraPlugins: "divarea,smiley,justify,indentblock,colordialog",
    colorButton_foreStyle: {
      element: "font",
      attributes: { color: "#(color)" },
    },
    height: 188,
    removeDialogTabs: "image:advanced;link:advanced",
    removeButtons: "Subscript,Superscript,Anchor,Source,Table",
    format_tags: "p;h1;h2;h3;pre;div",
  };


  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public regionProviders: RegionProvider,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService
  ) { }

  ngOnInit() {
    this.getRoles();
  }
  getRoles(){
    this.apiService.get(this.apiConfig.getRoleId).subscribe((res:any)=>{
      console.log(res)
      this.roleList = res.data;
      console.log("roleList",this.roleList);
    })
  }
  getFaqsData(id){
    this.apiService.get(this.apiConfig.getFaq+`?user_role_id=${id}`).subscribe((res:any)=>{
      this.faqData = res.data
    })
  }
  roleId:any ;
  selectRole(e){
    this.roleId = e;
    this.getFaqsData(e)
    this.show = true;
  }


  get f() {
    return this.formGroup.controls;
  }
  show:any = false;
  addFaq(modal){
    this.addOrEditFaq = 'add';
    this.modalService.open(modal,{size:'xl'});
    this.formGroup = this.fb.group({
      faq_question: new FormControl('', [Validators.required]),
      faq_answer: new FormControl ('', [Validators.required]),
      sequence_id: new FormControl('',[Validators.required]),
      user_role_id: new FormControl('', Validators.required)
    });
  }
  editFaq(modal, data){
    this.addOrEditFaq = 'edit';
    this.modalService.open(modal,{size:'xl'});
    this.formGroup = this.fb.group({
      id: data.id,
      user_role_id:new FormControl(this.roleId),
      faq_question: new FormControl(data.faq_question, [Validators.required]),
      faq_answer: new FormControl (data.faq_answer, [Validators.required]),
      sequence_id: new FormControl(data.sequence_id,[Validators.required]),
    });

  }
  onSubmitFAQ(formData) {
    console.log(formData);
    this.submitted = true;
    if (this.formGroup.invalid) {
      return
    }
    let apiUrl;
    if (this.addOrEditFaq == 'add') {
      apiUrl = this.apiConfig.addFaq
    } else if (this.addOrEditFaq == 'edit') {
      apiUrl = this.apiConfig.editFaq
    }
    this.apiService.post(apiUrl, formData)
      .subscribe((res: any) => {
        this.toast.Success(res.body.data.message);
        this.submitted = false;
        this.show = true;
        this.roleId =formData.user_role_id
        this.dismissModal(formData.user_role_id)
      }, err => {
      })
  }
  dismissModal(id){
    this.modalService.dismissAll();
    this.getFaqsData(id)
  }



}
